import { render, staticRenderFns } from "./editWarning.vue?vue&type=template&id=096a6973&scoped=true&"
import script from "./editWarning.vue?vue&type=script&lang=js&"
export * from "./editWarning.vue?vue&type=script&lang=js&"
import style0 from "./editWarning.vue?vue&type=style&index=0&id=096a6973&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096a6973",
  null
  
)

export default component.exports